import { render } from "./UploadComponentDocumento.vue?vue&type=template&id=01beb517&scoped=true"
import script from "./UploadComponentDocumento.vue?vue&type=script&lang=js"
export * from "./UploadComponentDocumento.vue?vue&type=script&lang=js"

import "./UploadComponentDocumento.vue?vue&type=style&index=0&id=01beb517&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01beb517"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn});
